<template>
  <div class="verificar-email">
    <el-main>
      <el-row class="verificar-email-container" :gutter="20">
        <el-col :span="24" class="verificar-email-card-container">
          <el-card class="verificar-email-card">
            <div v-if="status === 'loading'" class="estado">
              <i class="el-icon-loading estado-icone" aria-hidden="true"></i>
              <h3>{{ i18n.verificando }}</h3>
            </div>
            <div v-else class="estado">
              <i
                :class="[
                  'estado-icone',
                  status === 'success'
                    ? 'el-icon-success estado-icone--sucesso'
                    : 'el-icon-error estado-icone--erro'
                ]"
                aria-hidden="true"
              ></i>
              <h3>{{ tituloResultado }}</h3>
              <p class="descricao">{{ descricaoResultado }}</p>
              <p class="redirect-hint">
                {{ formatarMensagem("redirecionamentoEm", segundosRestantes) }}
              </p>
              <el-button type="primary" @click="irParaLogin">
                {{ formatarMensagem("irLoginComContagem", segundosRestantes) }}
              </el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import LoginService from "../../services/LoginService";
import { applyLocaleFromQuery } from "../../utils/i18nFromRoute";
import { isBrowserLanguagePortuguese } from "../../utils/browserUiLocale";

const SEGUNDOS_REDIRECIONAMENTO = 5;

export default {
  name: "VerificarEmail",
  data() {
    return {
      status: "loading",
      mensagemErro: null,
      segundosRestantes: SEGUNDOS_REDIRECIONAMENTO,
      redirectTimerId: null
    };
  },
  computed: {
    i18n() {
      const locale = this.$i18n && this.$i18n.locale;
      const pack =
        locale &&
        this.$i18n.messages[locale] &&
        this.$i18n.messages[locale].interface;
      return (pack && pack.conta && pack.conta.verificarEmail) || {};
    },
    tituloResultado() {
      return this.status === "success"
        ? this.i18n.sucessoTitulo
        : this.i18n.erroTitulo;
    },
    descricaoResultado() {
      if (this.status === "success") {
        return this.i18n.sucessoDescricao;
      }
      return this.mensagemErro || this.i18n.erroDescricao;
    }
  },
  mounted() {
    this.aplicarLocale();
    this.confirmarEmail();
  },
  beforeDestroy() {
    this.pararRedirecionamento();
  },
  methods: {
    aplicarLocale() {
      applyLocaleFromQuery(this);
      if (this.$route.query.lang === "en") {
        return;
      }
      if (isBrowserLanguagePortuguese()) {
        this.$i18n.locale = "PT-BR";
      } else {
        this.$i18n.locale = "EN";
      }
    },
    formatarMensagem(chave, valor) {
      const template = this.i18n[chave];
      if (!template) {
        return "";
      }
      return String(template).replace("{0}", String(valor));
    },
    async confirmarEmail() {
      const token = this.$route.query.token;
      if (!token || !String(token).trim()) {
        this.finalizarComErro(this.i18n.tokenAusente);
        return;
      }

      try {
        await LoginService.confirmarEmail(token);
        this.status = "success";
        this.$nextTick(() => this.iniciarRedirecionamento());
      } catch (err) {
        this.finalizarComErro((err && err.message) || null);
      }
    },
    finalizarComErro(mensagem) {
      this.status = "error";
      this.mensagemErro = mensagem;
      this.$nextTick(() => this.iniciarRedirecionamento());
    },
    iniciarRedirecionamento() {
      this.pararRedirecionamento();
      this.segundosRestantes = SEGUNDOS_REDIRECIONAMENTO;
      this.redirectTimerId = setInterval(() => {
        if (this.segundosRestantes <= 1) {
          this.irParaLogin();
          return;
        }
        this.segundosRestantes -= 1;
      }, 1000);
    },
    pararRedirecionamento() {
      if (this.redirectTimerId) {
        clearInterval(this.redirectTimerId);
        this.redirectTimerId = null;
      }
    },
    irParaLogin() {
      this.pararRedirecionamento();
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.verificar-email {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
}

.el-main {
  display: flex;
  justify-content: center;
}

.verificar-email-container {
  margin-top: 50px;
  width: 100%;
  max-width: 520px;
}

.verificar-email-card {
  border-radius: 10px;
  background: #fafbfc;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.verificar-email-card-container {
  display: flex;
  justify-content: center;
}

.estado {
  text-align: center;
  padding: 8px 12px 16px;
}

.estado h3 {
  color: #295661;
  font-family: Nunito, sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin: 12px 0;
}

.descricao {
  color: #3d4f57;
  font-size: 14px;
  line-height: 1.55;
  margin: 0 0 12px;
}

.redirect-hint {
  color: #295661;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  margin: 0 0 20px;
}

.estado-icone {
  font-size: 48px;
  color: #295661;
}

.estado-icone--sucesso {
  color: #2e7d32;
}

.estado-icone--erro {
  color: #c62828;
}
</style>
